import React, { FunctionComponent } from 'react';

import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { Select } from 'core/select/Select';
import { EducationalStatus } from 'social/publisher/Publisher.types';

interface Props {
    educationalStatuses: EducationalStatus[] | undefined;
    save: any;
}
type Option = {
    value: EducationalStatus;
    label: string;
};
const EDUCATIONAL_STATUS_OPTIONS: Option[] = [
    { value: EducationalStatus.HIGH_SCHOOL, label: 'HIGH_SCHOOL' },
    { value: EducationalStatus.UNDERGRADUATE, label: 'UNDERGRADUATE' },
    { value: EducationalStatus.ALUM, label: 'ALUM' },
    { value: EducationalStatus.HIGH_SCHOOL_GRAD, label: 'HIGH_SCHOOL_GRAD' },
    { value: EducationalStatus.SOME_COLLEGE, label: 'SOME_COLLEGE' },
    { value: EducationalStatus.ASSOCIATE_DEGREE, label: 'ASSOCIATE_DEGREE' },
    { value: EducationalStatus.IN_GRAD_SCHOOL, label: 'IN_GRAD_SCHOOL' },
    { value: EducationalStatus.SOME_GRAD_SCHOOL, label: 'SOME_GRAD_SCHOOL' },
    { value: EducationalStatus.MASTER_DEGREE, label: 'MASTER_DEGREE' },
    { value: EducationalStatus.PROFESSIONAL_DEGREE, label: 'PROFESSIONAL_DEGREE' },
    { value: EducationalStatus.DOCTORATE_DEGREE, label: 'DOCTORATE_DEGREE' },
    { value: EducationalStatus.UNSPECIFIED, label: 'UNSPECIFIED' },
    { value: EducationalStatus.SOME_HIGH_SCHOOL, label: 'SOME_HIGH_SCHOOL' },
];

export const EducationalStatusField: FunctionComponent<Props> = ({ educationalStatuses, save }) => {
    const { t } = useTranslation(['social/publisher']);
    const options = EDUCATIONAL_STATUS_OPTIONS.map((el) => {
        return { value: el.value, label: t(el.label) };
    });
    let selectedOptions: Option[] = [];

    if (educationalStatuses && educationalStatuses.length > 0) {
        selectedOptions = _.filter(options, (el) => _.includes(educationalStatuses, el.value));
    }

    const hanldeEducationalStatusChange = (selectedOptions: Option[]): void => {
        let newEducationalStatuses: EducationalStatus[] = [];

        if (selectedOptions && selectedOptions.length > 0) {
            newEducationalStatuses = selectedOptions.map((el) => el.value);
        }
        save(newEducationalStatuses);
    };

    return (
        <Select
            name="educational-status"
            className="educational-status-select"
            classNamePrefix="audience-targeting-educational-status"
            options={options}
            value={selectedOptions}
            onChange={hanldeEducationalStatusChange}
            isMulti
            placeholder={t('SELECT')}
        />
    );
};
